/**
 * Created by liuxi on 2023/12/21 10:25
 */
import React from 'react'

const Next: React.FC = () => {
  return <div>next</div>
}

export default Next
